module.exports = __webpack_public_path__ + "static/media/bg_bio_ornament.079cb576.jpg";